import axios from 'axios';

import { publicAxiosHeader, getV1RootUrl } from 'common/helpers/apiHelper';

export const listReservationAvailabilities = (queryString) =>
  axios.get(
    `${getV1RootUrl()}/reservation-availability/for-web?${queryString}`,
    publicAxiosHeader()
  );
